<app-dialog-sidebar>
    <div class="store-stock">

        @if (data.stockSidebarType === 'select') {
            <h2>{{ 'stock.headings.chooseStore' | translateSafe }}</h2>
            <p class="lead">{{ 'stock.lead.chooseStore' | translateSafe }}</p>
        } @else if (data.stockSidebarType === 'stock-status') {
            <h2>{{ 'stock.headings.storeStock' | translateSafe }}</h2>
            <p class="lead">{{ 'stock.lead.chooseStore' | translateSafe }}</p>
        } @else if (data.stockSidebarType === 'reserve-in-basket' || data.stockSidebarType === 'reserve') {
            <h2>{{ 'stock.headings.reserve' | translateSafe }}</h2>
            <p class="lead">{{ 'stock.lead.reserve' | translateSafe }}</p>
        } @else if (data.stockSidebarType === 'checkout') {
            <h2>{{ 'stock.headings.reserve' | translateSafe }}</h2>
        }

        <app-reserve-in-store
            *ngIf="
                data.stockSidebarType === 'checkout' && (storesService.favoriteStore$ | async) as favoriteStore;
                else showStoreList
            "
            [store]="favoriteStore"
            (closeOverlay)="closeOverlay()"
            (changeStore)="setStockSidebarType('reserve')"
        ></app-reserve-in-store>
        <ng-template #showStoreList>
            <app-store-stock-list
                [type]="data.stockSidebarType"
                (closeOverlay)="closeOverlay()"
                (reserveStoreChosen)="setStockSidebarType('checkout')"
            ></app-store-stock-list>
        </ng-template>

        <ng-template #pending>
            <app-loading-dots></app-loading-dots>
        </ng-template>
    </div>
</app-dialog-sidebar>
